export namespace Sounds {
  export const Channel = {
    SFX: 'sfx',
    Music: 'music'
  } as const;

  // Snd + Character + Partial + Number
  export const Partial = {
    // Vehicle
    Boost: 'Boost',
    EngineLoop: 'EngineLoop',
    Hit: 'Hit',
    PowerUp: 'Powerup',
    Charge: 'Charge',
    ChargeComplete: 'ChargeComplete',

    Caught: 'Caught',
    Cheer: 'Cheer',
    Whoa: 'VOWhoa',
    Punch: 'Punch',
    PreFire: 'PreFire',
    Fire: 'Fire',

    // Money
    Throw: 'SndThrow',
    PickUp: 'SndPickup'
  } as const;

  export const Character = {
    Bam: 'Bam',
    Prank: 'Prank',
    Bibi: 'Bibi',
    Jestah: 'Jestah',
    Batwing: 'Batwing',
    Quizz: 'Quizz',
    Redbird: 'Redbird',
    Ducky: 'Ducky',
    Buff: 'Buff',
    Snowy: 'Snowy'
  } as const;
  export type CharacterKeys = keyof typeof Character;
  export type CharacterValues = typeof Character[CharacterKeys];

  export const Track = {
    // Music
    Music: 'SndMusicLoop',

    // SFX
    Click: 'SndItemClick',

    Throw1: 'SndThrow1',
    Throw2: 'SndThrow2',
    Throw3: 'SndThrow3',

    BamBoost: 'SndBamBoost1',
    BamEngine: 'SndBamEngineLoop1',
    BamHit1: 'SndBamHit1',
    BamPowerup1: 'SndBamPowerup1',
    BamWhoa: 'SndBamVOWhoa',

    BatwingBoost: 'SndBatwingBoost1',
    BatwingEngine: 'SndBatwingEngineLoop1',
    BatwingHit1: 'SndBatwingHit1',
    BatwingNetFire1: 'SndBatwingNetFire1',
    BatwingWhoa: 'SndBatwingVOWhoa',

    BibiBoost: 'SndBibiBoost1',
    BibiEngine: 'SndBibiEngineLoop1',
    // BibiEngine1: 'SndBibiEngine1',
    BibiHit1: 'SndBibiHit1',
    BibiWhoa: 'SndBibiVOWhoa',

    BuffBoost: 'SndBuffBoost1',
    BuffEngine: 'SndBuffEngineLoop1',
    BuffHit1: 'SndBuffHit1',
    BuffCrane1: 'SndBuffCrane1',
    BuffWhoa: 'SndBuffVOWhoa',

    DuckyBoost: 'SndDuckyBoost1',
    DuckyEngine: 'SndDuckyEngineLoop1',
    DuckyFire1: 'SndDuckyFire1',
    DuckyPop1: 'SndDuckyPop1',
    DuckyPreFire1: 'SndDuckyPreFire1',

    JestahBoost1: 'SndJestahBoost1',
    JestahBoost2: 'SndJestahBoost2',
    JestahEngine: 'SndJestahEngineLoop1',
    JestahPreFire1: 'SndJestahPreFire1',
    JestahFire1: 'SndJestahFire1',

    PrankBoost1: 'SndPrankBoost1',
    PrankEngine: 'SndPrankEngineLoop1',
    PrankCaught1: 'SndPrankCaught1',
    PrankPreFire1: 'SndPrankPreFire1',
    PrankPunch1: 'SndPrankPunch1',
    PrankPunchRetract1: 'SndPrankPunchRetract1',

    QuizzBoost: 'SndQuizzBoost1',
    QuizzEngine: 'SndQuizzEngineLoop1',
    QuizzCaught1: 'SndQuizzCaught1',
    QuizzPreFire1: 'SndQuizzPreFire1',
    QuizzFire1: 'SndQuizzFire1',

    RedbirdBoost: 'SndRedbirdBoost1',
    RedbirdEngine1: 'SndRedbirdEngineLoop1',
    RedbirdEngine2: 'SndRedbirdEngineLoop2',
    RedbirdHit1: 'SndRedbirdHit1',
    RedbirdLaser1: 'SndRedbirdLaser1',
    RedbirdWhoa: 'SndRedbirdVOWhoa',

    SnowyBoost: 'SndSnowyBoost1',
    SnowyEngine: 'SndSnowyEngineLoop1',
    SnowyCranePickup1: 'SndSnowyCranePickup1',
    SnowyPreFire1: 'SndSnowyPreFire1',
    SnowyFire1: 'SndSnowyFire1',

    Charge1: 'SndCharge1',
    ChargeComplete1: 'SndChargeComplete1',
    CompAlarm1: 'SndCompAlarm1',
    CompOff1: 'SndCompOff1',
    CompOn1: 'SndCompOn1',
    CompOn2: 'SndCompOn2',
    CompSwitch1: 'SndCompSwitch1',
    Grapple1: 'SndGrapple1',
    Pickup1: 'SndPickup1',
    Pickup2: 'SndPickup2',

    BamCheer1: 'SndBamCheer1',
    BamLaugh1: 'SndBamLaugh1',
    BamLaugh2: 'SndBamLaugh2',
    BamLaugh3: 'SndBamLaugh3',

    BatwingCheer1: 'SndBatwingCheer1',
    BatwingLaugh1: 'SndBatwingLaugh1',
    BatwingLaugh2: 'SndBatwingLaugh2',
    BatwingLaugh3: 'SndBatwingLaugh3',

    BibiCheer1: 'SndBibiCheer1',
    BibiLaugh1: 'SndBibiLaugh1',
    BibiLaugh2: 'SndBibiLaugh2',
    BibiLaugh3: 'SndBibiLaugh3',

    BuffCheer1: 'SndBuffCheer1',
    BuffLaugh1: 'SndBuffLaugh1',
    BuffLaugh2: 'SndBuffLaugh2',
    BuffLaugh3: 'SndBuffLaugh3',

    RedbirdLaugh3: 'SndRedbirdLaugh3',
    RedbirdCheer1: 'SndRedbirdCheer1',
    RedbirdLaugh1: 'SndRedbirdLaugh1',
    RedbirdLaugh2: 'SndRedbirdLaugh2',

    SndBadIntro1: 'SndBadIntro1'
  } as const;
}
